import axiosSmartSurvey from "../../../api/axios"

export default function usefetchLtaxData() {
    const fetchLtaxData = async (param, value, parcelCode, land, setLand, setLandUsed, setOwner, setAllBuilding, prefixList, handleProvinceSelect, handleDistrictSelect, setBackDropLoading) => {
        const fetchLtaxBuildingData = async (landId) => {
            setBackDropLoading(true)
            var response = await axiosSmartSurvey({
                method: 'post',
                url: `/api/surveypredata`,
                data: { landId: landId }
            })
            var arr = []
            var arr2 = []
            var floorAmount = 0
            // console.log(response.data.data[0])
            response?.data.data.forEach((value, index) => {
                if (value.no_floor < 1) {
                    floorAmount = 1
                } else {
                    floorAmount = value.no_floor
                }
                for (let i = 0; i < floorAmount; i++) {
                    arr2 = [...arr2, {
                        floor: i + 1,
                        width: value.width,
                        length: value.length,
                        whoUsed: 1,
                        buildingUsed: {
                            mainLiving: 0,
                            otherLiving: 0,
                            agriculture: 0,
                            other: 0,
                            abandoned: 0,
                            value: 4
                        }
                    }]
                }

                // Convert Building Material 0 to 1
                var buildingMaterial
                if (value.b_material !== 0) {
                    buildingMaterial = value.b_material
                } else {
                    buildingMaterial = 1
                }
                // End Convert Building Material 0 to 1
                arr[index] = {
                    address: value.b_address,
                    buildingType: value.b_type,
                    buildingMaterial: buildingMaterial,
                    floorAmount: parseInt(floorAmount),
                    yearOfBuliding: value.build_year,
                    floorDetails: arr2,
                    owner: {
                        ltaxOwnerId: value.owner_id,
                        prefix: value.codemoi,
                        firstName: value.fname,
                        lastName: value.lname,
                        idCardNo: value.pop_id,
                        address: value.o_address,
                        road: value.o_road,
                        soi: value.o_soi,
                        moo: value.o_moo,
                        tumbolId: value.o_tumbol_id,
                        telephoneNo: value.telephone
                    },
                    ltaxBuildingId: value.bid,
                    buildingIndex: index
                }
                arr2 = []
            })
            setAllBuilding(arr)
            setBackDropLoading(false)
        }
        const fetchLtaxOwnerData = async (landId) => {
            var response = await axiosSmartSurvey({
                method: 'post',
                url: '/api/ownerid',
                data: { landId: landId }
            })
            response = response.data[0]
            var ownerData = {
                ltaxOwnerId: response.owner_id,
                firstName: response.fname,
                lastName: response.lname,
                idCardNo: response.pop_id,
                address: response.address,
                moo: response.moo,
                soi: response.soi,
                road: response.road,
                tumbolId: response.tumbol_id,
                tumbolName: response.tumbol_name,
                district: response.district,
                province: response.province,
                provinceCode: response.province_code,
                telephoneNo: response.telephone
            }
            await prefixList.forEach((data) => {
                if (data.short_prefix === response.prefix) {
                    ownerData.prefix = data.id
                }
            })
            if (response.o_type === 1) {
                ownerData.personType = 1
            } else {
                ownerData.personType = 2
            }
            setOwner(ownerData)
        }
        const fetchLtaxLandData = async (landId, parcelCode) => {
            var response = await axiosSmartSurvey({
                method: 'post',
                url: `/api/landdata`,
                data: { landId: landId }
            })
            response = response.data[0]
            // console.log(Number(response.w).toFixed(2))
            setLand({
                ...land,
                landId: response.lid,
                parcelCode: parcelCode,
                landType: parseInt(response.l_type),
                dn: response._dn,
                rawang: response.rw,
                landNo: response.ln,
                surveyNo: response.sn,
                rai: response.r,
                ngan: response.y,
                squareWa: Number(response.w).toFixed(2),
                soi: response.soi,
                moo: response.moo,
                road: response.road,
                tumbolId: response.tambon_id
            })
            setLandUsed([{
                value: 3,
                rai: response.r,
                ngan: response.y,
                squareWa: Number(response.w).toFixed(2),
                note: ''
            }])
        }
        setBackDropLoading(true);
        var url = `/api/surveypreinsert?`
        if (value) {
            url += `${param}=${value}`
        } else {
            // console.log(lid)
        }
        // console.log(url)
        const response = await axiosSmartSurvey.post(url)
        // console.log(response)
        if (response?.data?.length > 0) {
            fetchLtaxOwnerData(response.data[0].id)
            fetchLtaxLandData(response.data[0].id, parcelCode)
            fetchLtaxBuildingData(response.data[0].id)
        }
        setBackDropLoading(false)
    }


    // // 1. แยก API Calls ออกมาเป็นฟังก์ชันอิสระ
    // const getBuildingData = async (landId) => {
    //     const { data } = await axiosSmartSurvey.post('/api/surveypredata', { landId });

    //     return data.data.map((item, index) => {
    //         const floorAmount = item.no_floor < 1 ? 1 : item.no_floor;

    //         // สร้างข้อมูลชั้นแบบ Clean ด้วย Array.from
    //         const floorDetails = Array.from({ length: floorAmount }, (_, i) => ({
    //             floor: i + 1,
    //             width: item.width,
    //             length: item.length,
    //             whoUsed: 1,
    //             buildingUsed: { mainLiving: 0, otherLiving: 0, agriculture: 0, other: 0, abandoned: 0, value: 4 }
    //         }));

    //         return {
    //             address: item.b_address,
    //             buildingType: item.b_type,
    //             buildingMaterial: item.b_material || 1,
    //             floorAmount: parseInt(floorAmount),
    //             yearOfBuliding: item.build_year,
    //             floorDetails,
    //             owner: {
    //                 ltaxOwnerId: item.owner_id,
    //                 prefix: item.codemoi,
    //                 firstName: item.fname,
    //                 lastName: item.lname,
    //                 idCardNo: item.pop_id,
    //                 // ... (field อื่นๆ ตามเดิม)
    //             },
    //             ltaxBuildingId: item.bid,
    //             buildingIndex: index
    //         };
    //     });
    // };

    // // 2. ฟังก์ชันหลักที่เรียกใช้งาน
    // const fetchLtaxData = async (param, value, parcelCode, helpers) => {
    //     console.log(param, value, parcelCode, helpers)
    //     const { setLand, setLandUsed, setOwner, setAllBuilding, setBackDropLoading, prefixList } = helpers;

    //     try {
    //         setBackDropLoading(true);

    //         // ดึงข้อมูลเบื้องต้นเพื่อเอา landId
    //         const { data: preInsertData } = await axiosSmartSurvey.post(`/api/surveypreinsert?${param}=${value}`);

    //         if (preInsertData?.length > 0) {
    //             const landId = preInsertData[0].id;

    //             // ยิง API 3 ตัวพร้อมกันเพื่อลดเวลา Wait (Performance Boost)
    //             const [ownerRes, landRes, buildings] = await Promise.all([
    //                 axiosSmartSurvey.post('/api/ownerid', { landId }),
    //                 axiosSmartSurvey.post('/api/landdata', { landId }),
    //                 getBuildingData(landId)
    //             ]);
    //             console.log(ownerRes, landRes, buildings)

    //             // --- จัดการข้อมูล Owner ---
    //             const ownerRaw = ownerRes.data[0];
    //             const prefixMatch = prefixList.find(p => p.short_prefix === ownerRaw.prefix);
    //             setOwner({
    //                 ...ownerRaw, // ใช้ spread แทนการพิมพ์ทีละบรรทัด
    //                 ltaxOwnerId: ownerRaw.owner_id,
    //                 prefix: prefixMatch?.id || '',
    //                 personType: ownerRaw.o_type === 1 ? 1 : 2
    //             });

    //             // --- จัดการข้อมูล Land ---
    //             const landRaw = landRes.data[0];
    //             const landPayload = {
    //                 landId: landRaw.lid,
    //                 parcelCode,
    //                 landType: parseInt(landRaw.l_type),
    //                 dn: landRaw._dn,
    //                 squareWa: Number(landRaw.w).toFixed(2),
    //                 // ... (field อื่นๆ)
    //             };
    //             setLand(landPayload);
    //             setLandUsed([{ value: 3, rai: landRaw.r, ngan: landRaw.y, squareWa: landPayload.squareWa, note: '' }]);

    //             // --- จัดการข้อมูล Buildings ---
    //             setAllBuilding(buildings);
    //         }
    //     } catch (error) {
    //         console.error("Fetch Ltax Error:", error);
    //         // แสดง Swal.fire Error ที่นี่ได้
    //     } finally {
    //         setBackDropLoading(false);
    //     }
    // };
    return { fetchLtaxData }
}